import { render, staticRenderFns } from "./CustomerDialog.html?vue&type=template&id=4d2c633a&scoped=true&external"
import script from "./CustomerDialog.js?vue&type=script&lang=js&external"
export * from "./CustomerDialog.js?vue&type=script&lang=js&external"
import style0 from "./CustomerDialog.scss?vue&type=style&index=0&id=4d2c633a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2c633a",
  null
  
)

export default component.exports